/* src/components/Chat/ChatSearchBar.js */
import React from 'react';
import PropTypes from 'prop-types';
import './ChatSearchBar.css';

const ChatSearchBar = ({ value, onChange }) => {
    return (
        <div className="chat-search-bar">
            <input
                type="text"
                placeholder="Search chats..."

                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                aria-label="Search chats"
            />
        </div>
    );
};

ChatSearchBar.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default ChatSearchBar;